"use client";

/** Fires one first-party event when an SEO page is viewed. The listing
 *  page IS the listing, so its readers never fired `listing.open` and
 *  read as bounces (SEO review, 2026-10-02). */
import { useEffect } from "react";
import { trackEvent } from "@/lib/tracking";

export default function TrackView({ name, props }: { name: string; props: Record<string, unknown> }) {
  const key = JSON.stringify(props);
  useEffect(() => {
    trackEvent(name, props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, key]);
  return null;
}
